import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import config from 'config/default.json';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { RawSettingComponent } from './raw-setting/raw-setting.component';

@Component({
  selector: 'app-project-creation',
  templateUrl: './project-creation.component.html',
  styleUrls: ['./project-creation.component.scss','../../components/table/table.component.scss']
})
export class ProjectCreationComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() platformInfos: any;
  @Input() filterData:any;
  suppliers: any[] = [];
  formats: any[] = [];

  ngOnInit() {
    this.loadData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterData'] && !changes['filterData'].firstChange) {
      this.loadData();
    }
  }
  loadData(){
     if(this.filterData && Object.keys(this.filterData).length > 0){
      this.inProgress.emit(true);
      this.filterData.offset = this.navIndex * this.filterData.limit;
      this.apiService.queryData(config.master.ndapi.url + `/enovsky/web/raw-content/load_${this.platformInfos.key}`, this.filterData, this.userInfos['access_token']).subscribe((response)=>{
        this.dataSource = response.map((row:any) => {
          row["expanded"] = false;
          row["pdf_data"] = false;
          row["split_pages"] = null;
          return row;
        });
        this.showedRows = this.dataSource;
        this.formats = Array.from(new Set(response.map(el=>el.format)));
        this.suppliers = Array.from(new Set(response.map(el=>el.supplier)));
        this.totalRows = this.dataSource?.[0]?.total_rows ?? 0;
        this.totalNavigations = Math.ceil(this.totalRows / this.filterData.limit);
        this.inProgress.emit(false);
      });
    }
  }
  callBackEvent(row:any){
    console.log(row.split_pages)
    const index = this.showedRows.findIndex(e => e['id'] === row.id_content);
    if (index !== -1) this.dataSource[index].split_pages = row.split_pages;
  }
  /* getFileUrl(row:any){
    this.sharedService.sendData({in_progress: true});
    let data = {
      table: 'generate_files_urls',
      files_path: {file: this.platformInfos['root']+'/'+row['file_path']+'.pdf'}
    }
    //Get file
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    this.apiService.queryData(config.service.cloud.url + '/generate_files_urls', formData, this.userInfos['access_token']).subscribe(async(response:any)=>{
      let fileUrl = response['file'].file_url;
      const index = this.showedRows.findIndex(e => e['id'] === row.id);
      //if (index !== -1) this.showedRows[index]['pdf_data'] = {contents: [{id_content: row['id'], url: fileUrl}], height: 320, refresh: true};
      this.sharedService.sendData({in_progress: false});
    });
  } */
  rawSetting(){
    let selectedRows = this.selectRows();
    if(selectedRows.length){
      const dialogRef = this.dialog.open(RawSettingComponent, {
        width: '70%',
        position: {top: '30px' },
        data: {user_infos: this.userInfos, selected_rows: selectedRows, platform_infos: this.platformInfos, product_name: `Project ${this.userInfos['id_user']} ${(new Date().toJSON().slice(0,10))}`}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
        if(response && response.action == 'delete_content'){
          this.dataSource = this.dataSource.filter((el:any)=> !response.delete_rows.includes(el.id));
          this.showedRows = this.showedRows.filter((el:any)=> !response.delete_rows.includes(el.id));
        }
      });
    }else this.helper.showToast('Select contents first...');
  }
  

  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
      this.cdRef.detectChanges();
      if(row['expanded']){
        const index = this.showedRows.findIndex(e => e['id'] === row.id);
        if (index !== -1) this.showedRows[index]['pdf_data'] = {contents: [{id_content: row['id'], url: this.platformInfos['root']+'/'+row['file_path']+'.pdf'}], source: 'service', height: 320, refresh: true};
      }
    }
  }
  removeChildsFromElement(element:any){
    while (element && element.hasChildNodes()) {
      element.removeChild(element.lastChild);
    }
  }
  movePrevNextNavigation(action:string) {
    if (action == 'prev' && this.navIndex > 0) {
      this.navIndex--;
      this.loadData();
    }
    if (action == 'next' && this.navIndex < this.totalNavigations - 1) {
      this.navIndex++;
      this.loadData();
    }
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
}
